import EnablerApi from "../api/EnablerApi";
import logger from "../logger";

const loadStates = {
  EMPTY: "empty",
  LOADING: "loading",
  LOADED: "loaded",
};

class Enabler {
  features = {};

  enablerApi;

  rootStore;

  loadState = loadStates.EMPTY;

  constructor(rootStore) {
    this.rootStore = rootStore;

    this.enablerApi = new EnablerApi();
  }

  getFeatures = async () => {
    this.loadState = loadStates.LOADING;

    try {
      const response = await this.enablerApi.getFeatures();

      response.data.forEach((featureData) => {
        this.features[featureData.id] = featureData;
      });

      this.loadState = loadStates.LOADED;
    } catch (error) {
      console.log("Can't get features from enabler. Error:", error);
      this.loadState = loadStates.EMPTY;
      logger.error(error, {
        sentryTitle: "Header: error while loading feature data from enabler",
        sentryMessage: `Header: ${error}, ${error.message}`,
      });
    }
  };

  markAsViewed = async (id) => {
    try {
      await this.enablerApi.setView(id);
    } catch (error) {
      console.error("Can't mark feature from enabler as viewed: ", error);

      logger.error(error, {
        sentryTitle: "Header: error while trying to mark a feature as viewed",
        sentryMessage: `Id: ${id}; Error: ${error}`,
      });
    }
  };

  getFeaturesByIdList = async (idList) => {
    if (this.loadState === loadStates.EMPTY) {
      await this.getFeatures();
    }

    return idList.map((id) => this.features[id]);
  };

  getFeatureById = async (featureId) => {
    if (this.loadState === loadStates.EMPTY) {
      await this.getFeatures();
    }

    return this.features[featureId];
  };
}

export default Enabler;
